export interface IBranch {
  id: string;
  name: string;
  isRestaurant?: boolean;
}

export default class Branch implements IBranch {
  id: string;
  name: string;
  message: string;
  imageUrl: string;
  typeBanner: string;
  imageFileType: string;

  constructor(id: string, name: string, message: string , imageUrl: string, typeBanner: string, imageFileType: string) {
    this.id = id;
    this.name = name;
    this.message = message;
    this.imageUrl = imageUrl;
    this.typeBanner = typeBanner;
    this.imageFileType = imageFileType
  }
}
